import Network from '@/services/network'
import {ref} from 'vue'

export default function handleCompanyContact() {
    const network = new Network;
    const loading = ref(false)

    //Contact register
    const fetchCompanyAllContacts = (query) => {
        return network.api('get', `/company/contacts/list` + query);
    }
    const fetchContactDetails = (type, id, query) => {
        return network.api('get', `/company/contacts/details/${type}/${id}` + query);
    }

    // Add contact
    const fetchCompanyContacts = (query) => {
        return network.api('get', `/company/contacts` + query);
    }
    const fetchEmployeeList = (query) => {
        return network.api('get', `/company/contacts/employee-list` + query);
    }
    const fetchClientRegister = (query) => {
        return network.api('get', `/company/contacts/client-register` + query);
    }
    const fetchSingleCompanyContact = (query, id) => {
        return network.api('get', `/company/contacts/${id}` + query);
    }
    const fetchSingleCompanyContactItems = (query, id) => {
        return network.api('get', `/company/contacts/items/${id}` + query);
    }
    const fetchContactProfileBySerialNo = (query) => {
        return network.api('get', `/company/contacts/contact-profile-by-serial-no` + query);
    }
    const storeCompanyContact = (data, query) => {
        return network.api('post', '/company/contacts' + query, data);
    }
    const storeCompanyContactsItems = (data, query) => {
        return network.api('post', '/company/contacts/items' + query, data);
    }
    const storeAdditionalContactItems = (contact_id, data, query) => {
        return network.api('post', `/company/contacts/additional-items/${contact_id}` + query, data);
    }
    const updateContactDealer = (contact_id, data) => {
        return network.api('post', `/company/contacts/update-contact-dealer/${contact_id}`, data);
    }
    const storeUpdateContactFile = (contact_id, data, query) => {
        return network.api('post', `/company/contacts/file-upload/${contact_id}` + query, data);
    }

   const fetchContactWithProjects = (query) => {
        return network.api('get', `/company/contacts/fetch-contact-with-projects` + query);
    }
    const fetchContactWithProjectsActivity = (query) => {
        return network.api('get', `/company/contacts/fetch-contact-with-projects-activity` + query);
    }
    const projectWorkStatusUpdate = (data) => {
        return network.api('post', '/company/contacts/work-status-update', data);
    }
    const fetchWorkStatusReport = (query) => {
        return network.api('get', `/company/contacts/work-status-report` + query);
    }
    const fetchProjectTimesheetReport = (query) => {
        return network.api('get', `/company/contacts/project-timesheet-report` + query);
    }
    //Contact import
    const uploadContacts = (data) => {
        return network.api('post', '/company/contacts/upload-contacts', data);
    }
    const uploadUpdateContacts = (data) => {
        return network.api('post', '/company/contacts/upload-update-contacts', data);
    }
    const insertContacts = (data) => {
        return network.api('post', '/company/contacts/final-contact-upload', data);
    }
    const updateContacts = (data) => {
        return network.api('post', '/company/contacts/final-contact-upload-update', data);
    }

    //Activity Logs
    const fetchActivityLogs = (query) => {
        return network.api('get', '/company/contacts/activity-logs' + query);
    }
    const storeActivityLogs = (data, query) => {
        return network.api('post', '/company/contacts/activity-logs' + query, data);
    }
    const updateActivityLogs = (id, data, query) => {
        return network.api('post', `/company/contacts/activity-logs/${id}` + query, data);
    }
    const fetchActivityDetails = (query) => {
        return network.api('get', `/company/contacts/activity-details` + query);
    }
    const fetchActivityLogsList = (query) => {
        return network.api('get', `/company/contacts/activity-logs-list` + query);
    }

    return {
        fetchCompanyAllContacts,
        fetchContactDetails,

        fetchCompanyContacts,
        fetchEmployeeList,
        fetchClientRegister,
        fetchSingleCompanyContact,
        fetchSingleCompanyContactItems,
        storeCompanyContact,
        fetchContactProfileBySerialNo,
        storeCompanyContactsItems,
        storeAdditionalContactItems,
        updateContactDealer,
        storeUpdateContactFile,
        uploadContacts,
        uploadUpdateContacts,
        fetchContactWithProjects,
        fetchContactWithProjectsActivity,
        projectWorkStatusUpdate,
        fetchWorkStatusReport,
        fetchProjectTimesheetReport,
        insertContacts,
        updateContacts,
        fetchActivityLogs,
        storeActivityLogs,
        updateActivityLogs,
        fetchActivityDetails,
        fetchActivityLogsList,
        loading
    }
}
